import {
  FilterOutlined,
  ApartmentOutlined,
  TableOutlined,
  UndoOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { Tooltip, Button, Result, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GetFilteredIndividualPerformanceApi from "../../api/individuals/GetFilteredIndividualPerformanceApi";
import GetPositionsPerformanceApi from "../../api/individuals/GetPositionsPerformanceApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddUserModal from "../../components/modal/add/AddUserModal";
import IndividualPerformanceFilterModal from "../../components/modal/filters/IndividualPerformanceFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import PositionsPerformanceTable from "../../components/tables/PositionsPerformanceTable";

import IndividualsTree from "../../components/tree/IndividualsTree";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function PositionsPerformance() {
  const [canStart, setCanStart] = useState(false);
  const [data, setData] = useState(false);
  const [tree, setTree] = useState(false);
  const [page, setPage] = useState(1);
  const [tableLoading, setTableLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const proHeight = document.body.clientHeight;
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const positionState = useSelector((state) => state.positionState.value);

  let navigate = useNavigate();

  useEffect(() => {
    getPositions(1);
  }, [perfCycleState]);

  async function getPositions(num) {
    setTableLoading(true);
    const apiResponse = await GetPositionsPerformanceApi(
      perfCycleState.id,
      num,
      positionState.id,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setData(apiResponse.data);
      setCanStart(true);
      setTableLoading(false);
      setPage(num);
    }
  }
  async function getFilteredPositionPerformance(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredIndividualPerformanceApi(
      perfCycleState.id,
      values.designation || "",
      values.role || "",
      values.unit || "",
      positionState.id,
      num,
      LIMIT_PER_PAGE
    );
    

    if (apiResponse.message === "success") {
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterStatus(true);
      setFilterBy({
        designation: values.designation,
        role: values.role,
        unit: values.unit,
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilteredPositionPerformance(filterBy, num);
    } else {
      getPositions(num);
    }
  }

  function resetFilter() {
    setFilterStatus(false);
    getPositions(1);
    setFilterBy();
  }

  const right = (
    <>
      {canStart && !tree && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">Positions</div>
      {/* {data &&
        (tree ? (
          <Tooltip title={"Table view"}>
            <Button onClick={() => setTree(false)} className="ml-3">
              <TableOutlined />
            </Button>
          </Tooltip>
        ) : (
          <Tooltip title={"Tree view"}>
            <Button onClick={() => setTree(true)} className="ml-3">
              <ApartmentOutlined />
            </Button>
          </Tooltip>
        ))} */}
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            tree ? (
              <IndividualsTree />
            ) : (
              <PositionsPerformanceTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddUserModal
        visible={addModal}
        handleCancel={() => {
          setAddModal(false);
          setData("now");
        }}
      />
      <IndividualPerformanceFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilteredPositionPerformance(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default PositionsPerformance;
